import React, { useState, useEffect, useRef } from "react";
import { useGlobalContext } from "context/global";
import useCartSummary from "hooks/useCartSummary";
import Money from "components/money";
import RichText from "components/rich-text";
import clsx from "clsx/lite";
import CosmeticRadio from "components/cosmetic-radio";

const BundleVariantOption = ({ bundle, isActive, setSelectedBundle }) => {
	const { translation, cartSettings } = useGlobalContext();
	const bundleWeight = bundle.product.variant.weight;
	const currentBox = cartSettings.boxes.find(box => box.size.value === bundleWeight);
	const bundleSummary = useCartSummary({
		currentBox, products: [{ ...bundle.product, quantity: 1 }],
		totalWeight: bundleWeight,
		calcFirstOrderDiscount: true
	});

	const description = bundle.description || bundle.product.details?.description;

	const descriptionRef = useRef(null);
	const [descriptionHeight, setDescriptionHeight] = useState(0);

	useEffect(() => {
		if (isActive && descriptionRef.current) {
			setDescriptionHeight(descriptionRef.current.scrollHeight);
		} else {
			setDescriptionHeight(0);
		}
	}, [isActive, description]);

	return (
		<button
			key={bundle._key}
			onClick={() => setSelectedBundle(bundle)}
			className={clsx(
				"px-5 py-4 w-full border-beige border-2 rounded-xl",
				isActive && "border-black",
			)}
		>
			<div className="flex justify-between">
				<div className="flex flex-row">
					<CosmeticRadio checked={isActive} />
					<div className="flex flex-col items-start gap-y-2">
						<p className={clsx("text-left text-sm md:text-base font-boldParagraph")}>{bundle.title}</p>
						{bundle.label && <span className="bg-green-discount text-smaller px-3 py-1 rounded-xl">{bundle.label}</span>}
					</div>
				</div>
				<div className="flex flex-col gap-y-2">
					<div className="flex gap-x-1">
						{bundleSummary.boxPrice !== bundleSummary.pricePerMeal && (
							<span className="line-through text-small md:text-sm text-secondary">
								<Money value={bundleSummary.boxPrice} />
							</span>
						)}
						<span className="font-boldParagraph text-small md:text-sm">
							<Money value={bundleSummary.pricePerMeal} minimumFractionDigits={0} />
						</span>
						<strong className="uppercase text-small md:text-sm">/{translation.cart?.meal}</strong>
					</div>
					<span className="text-secondary text-small">
						<Money value={bundleSummary.totalPrice} />{" "}
						{translation.shopping_flow?.in_total}{" "}
					</span>
				</div>
			</div>

			{isActive && description && (
				<div
					ref={descriptionRef}
					className="flex justify-start w-full mt-3 overflow-hidden"
					style={{
						maxHeight: descriptionHeight,
						transition: "max-height 0.3s ease-out",
					}}
				>
					<RichText value={description} isFullWidth className="!text-left text-[#585D63]" />
				</div>
			)}
		</button>
	);
};

export default BundleVariantOption;